import { useBrowserSupport } from './use-browser-support'

export interface CustomNavigator extends Navigator {
    setAppBadge: (contents: number) => Promise<void>
    clearAppBadge: () => Promise<void>
}

export interface IAppBadge {
    setAppIconBadge: (count: number) => Promise<void>
    clearAppBadge: () => Promise<void>
}

export function useAppBadge (): IAppBadge {
  function setAppIconBadge (count: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const { canUseAppBadge } = useBrowserSupport()
      const isBrowserSupport = canUseAppBadge()
      if (isBrowserSupport) {
        (navigator as CustomNavigator).setAppBadge(count)
        resolve()
      } else {
        reject('browserNotSupportSetAppBadge')
      }
    })
  }

  function clearAppBadge (): Promise<void> {
    return new Promise((resolve, reject) => {
      const { canUseClearAppBadge } = useBrowserSupport()
      const isBrowserSupport = canUseClearAppBadge()
      if (isBrowserSupport) {
        (navigator as CustomNavigator).clearAppBadge()
        resolve()
      } else {
        reject('browserNotSupportClearAppBadge')
      }
    })
  }

  return {
    setAppIconBadge,
    clearAppBadge,
  }
}
